import React from 'react';
import { connect } from 'react-redux';
import { withHandlers, compose, withState } from 'recompose';
import { getUpdatedTextWithEmoji } from '../../../../../common/components/EmojiPicker/emoji-picker-helpers';
import { EmojiPicker } from '../../../../../common/components/EmojiPicker/EmojiPicker';
import Textarea from '../../../../../common/components/Textarea';
import {
  getDefaultHeading, getDefaultText, ALIGNMENT_TYPES,
  MESSENGER_BUTTON_MESSAGES,
} from '../../constants/constants';
import BackgroundEditor from './BackgroundEditor';
import LogoEditor from './LogoEditor';
import Select from '../../../../../common/components/MainSelect/MainSelect';
import { facebookFromActiveBotPageSelector } from "@mm/state/selectors/facebookPageSelector";
import './LandingPageDesign.scss';
import '../../../../../common/scss/input.scss';

const TextAreaBase = props => {
  const {
    value,
    onValueChange,
    validate,
    inputName,
    placeholder,
    maxLength,
    updateInsertEmoji,
    setInputRef,
  } = props;

  return (
    <div className="landing-page-design__input-container">
      <div className="landing-page-design__name-container">
        <div className="landing-page-design__field-title">
          <span>{inputName}</span>
          <EmojiPicker onEmojiPicked={updateInsertEmoji} />
        </div>
        <Textarea
          placeholder={placeholder}
          className="landing-page-design__textarea"
          maxLength={maxLength}
          onChange={onValueChange}
          inputRef={setInputRef}
          onBlur={validate}
          value={value}
        />
      </div>
    </div>
  );
}

const LandingPageDesign = props => {
  const {
    fbPageName,
    formPageHeading, updateFormPageHeading,
    formPageText, updateFormPageText,
    formBgColor, updateFormBgColor,
    setHeaderInputRef,
    updateInsertEmojiHeading,
    updateInsertEmojiPageText,
    setPageTextInputRef,
    formImageNewUrl, setFormImageNewUrl,
    selectedEntity, formImageUrl, setFormImageUrl,
    formTextAlignment, setFormTextAlignment,
    formMsgButtonText, setMsgButtonText,
  } = props;

  return (
    <div>
      <BackgroundEditor
        formBgColor={formBgColor}
        updateFormBgColor={updateFormBgColor}
        selectedEntity={selectedEntity}
      />
      <LogoEditor
        formImageNewUrl={formImageNewUrl}
        setFormImageNewUrl={setFormImageNewUrl}
        selectedEntity={selectedEntity}
        formImageUrl={formImageUrl}
        setFormImageUrl={setFormImageUrl}
      />
      <TextAreaBase
        value={formPageHeading}
        setInputRef={setHeaderInputRef}
        updateInsertEmoji={updateInsertEmojiHeading}
        onValueChange={e => updateFormPageHeading(e.target.value)}
        maxLength="255"
        inputName="Heading"
        placeholder={getDefaultHeading(fbPageName)}
      />
      <TextAreaBase
        value={formPageText}
        updateInsertEmoji={updateInsertEmojiPageText}
        setInputRef={setPageTextInputRef}
        onValueChange={e => updateFormPageText(e.target.value)}
        maxLength="2000"
        inputName="Text"
        placeholder={getDefaultText(fbPageName)}
      />
      <div>
        <div className="landing-page-design__field-title">Text alignment</div>
        <div>
          <Select
            className="chatbot__input"
            onChange={e => setFormTextAlignment(e.target.value)}
            value={formTextAlignment}
          >
            <option value={ALIGNMENT_TYPES.CENTER}>Center</option>
            <option value={ALIGNMENT_TYPES.LEFT}>Left</option>
            <option value={ALIGNMENT_TYPES.RIGHT}>Right</option>
          </Select>
        </div>
      </div>
      <div>
        <div className="landing-page-design__field-title">Button text</div>
        <div>
          <Select
            className="chatbot__input"
            onChange={e => setMsgButtonText(e.target.value)}
            value={formMsgButtonText}
          >
            {
              Object.keys(MESSENGER_BUTTON_MESSAGES).map(msgType => (
                <option value={msgType}>{MESSENGER_BUTTON_MESSAGES[msgType]}</option>
              ))
            }
          </Select>
        </div>
      </div>
    </div>)
}

const mapStateToProps = state => ({
  fbPageName: facebookFromActiveBotPageSelector(state),
});

const updateInsertEmojiHeading = props => emoji => {
  const { updateFormPageHeading, formPageHeading, headerInputRef } = props;
  const newText = getUpdatedTextWithEmoji(formPageHeading, emoji, headerInputRef);

  updateFormPageHeading(newText);
};

const updateInsertEmojiPageText = props => emoji => {
  const { updateFormPageText, formPageText, pageTextInputRef } = props;
  const newText = getUpdatedTextWithEmoji(formPageText, emoji, pageTextInputRef);

  updateFormPageText(newText);
};


const enhance = compose(
  connect(mapStateToProps),
  withState('headerInputRef', 'setHeaderInputRef', null),
  withState('pageTextInputRef', 'setPageTextInputRef', null),
  withHandlers({ updateInsertEmojiHeading, updateInsertEmojiPageText }),
);

export default enhance(LandingPageDesign);
